<template>
    <span v-text="formatDate(value, format)"></span>
</template>
<script>
import { formatDateMixin } from '@/mixins/dates';
export default {
    name: 'issue-startedAt',
    data: () => ({}),
    mixins: [formatDateMixin],
    props: {
        value: {},
        format: {
            default: 'dd/MM/yyyy HH:mm',
        },
    },
};
</script>
